import * as React from "react";
import type { SVGProps } from "react";
const SvgPxSuperuserDetail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 15 15"
    {...props}
  >
    <g data-name="Group 48624">
      <g data-name="Group 33532">
        <path fill="none" d="M2 2h12v12H2z" data-name="Rectangle 21199" />
        <g data-name="Group 29060">
          <g data-name="Group 29056">
            <g data-name="Group 29055">
              <path
                fill="#ff9300"
                d="M6.561 2.27a2.8 2.8 0 1 0 2.8 2.8 2.806 2.806 0 0 0-2.8-2.8"
                data-name="Path 30939"
              />
            </g>
          </g>
          <g data-name="Group 29058">
            <g data-name="Group 29057">
              <path
                fill="#ff9300"
                d="M13.229 8.989q-.008-.2-.006-.394a.18.18 0 0 0-.184-.184 2.47 2.47 0 0 1-1.838-.695.19.19 0 0 0-.258 0 2.47 2.47 0 0 1-1.838.695.18.18 0 0 0-.184.184q.002.192-.006.394c-.025 1.291-.062 3.062 2.1 3.806l.061.012.061-.012c2.142-.744 2.112-2.509 2.092-3.806m-2.306 1.789a.2.2 0 0 1-.129.049h-.006a.17.17 0 0 1-.129-.062l-.572-.633.277-.246.449.5 1-.947.252.271Z"
                data-name="Path 30940"
              />
            </g>
          </g>
          <g data-name="Group 29059">
            <path
              fill="#ff9300"
              d="M10.777 12.898c-2.158-.744-2.121-2.515-2.1-3.806 0-.1.006-.2.006-.3a4 4 0 0 0-1.5-.292H5.94a4 4 0 0 0-2.864 1.208 4.09 4.09 0 0 0-1.184 2.88.31.31 0 0 0 .311.311h8.573Z"
              data-name="Path 30941"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgPxSuperuserDetail;
